/** Default body copy for the "Coming soon" card (e.g. collaborator-gated matter features). */
export const kDefaultComingSoonMessage = 'Collaboration isn’t supported on this feature yet, but updates are on the way. Check back soon.'
